module.exports = __webpack_public_path__ + "img/logo.eff38366.svg";